import * as Icons from "lucide-react";

const ICON = (name) => {
  const C = Icons[name] || Icons.Sparkles;
  return <C className="h-5 w-5" strokeWidth={1.4} />;
};

export default function Services({ data }) {
  const label = data?.label || "What we help with";
  const headline = data?.headline || "Everything you need. Nothing you don't.";
  const intro = data?.intro || "";
  const items = data?.items || [];

  // Italicise the second sentence
  const renderHeadline = () => {
    const parts = headline.split(/\.\s+/);
    if (parts.length >= 2) {
      const first = parts.slice(0, -1).join(". ") + ".";
      const last = parts[parts.length - 1];
      return (
        <>
          {first}<br />
          <em className="italic font-light text-gold not-italic">{last}</em>
        </>
      );
    }
    return headline;
  };

  return (
    <section
      id="services"
      data-testid="services-section"
      className="relative bg-charcoal text-ivory py-20 md:py-32 overflow-hidden"
    >
      <div className="absolute inset-x-0 top-0 h-px bg-gradient-to-r from-transparent via-gold/40 to-transparent" />

      <div className="max-w-7xl mx-auto px-5 md:px-10">
        <div className="grid grid-cols-12 gap-8 mb-14 md:mb-20">
          <div className="col-span-12 md:col-span-7">
            <div className="reveal flex items-center gap-3 mb-5">
              <span className="h-px w-10 bg-gold" />
              <span className="eyebrow text-gold">{label}</span>
            </div>
            <h2
              data-testid="services-headline"
              className="reveal font-display text-[2.25rem] leading-[1.05] sm:text-5xl md:text-6xl tracking-tight text-ivory"
            >
              {renderHeadline()}
            </h2>
          </div>
          <div className="col-span-12 md:col-span-5 md:pl-6 self-end">
            <p className="reveal font-display text-2xl md:text-3xl italic text-ivory/80 leading-snug">
              {intro}
            </p>
          </div>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-px bg-ivory/10 border border-ivory/10">
          {items.map((s, i) => (
            <div
              key={`${s.title}-${i}`}
              data-testid={`services-item-${i}`}
              className="reveal group bg-charcoal hover:bg-teal-700 transition-colors duration-500 p-7 md:p-8 flex items-start gap-4 min-h-[120px]"
            >
              <span className="text-gold group-hover:text-ivory transition-colors mt-1">
                {ICON(s.icon)}
              </span>
              <div className="font-display text-xl md:text-2xl text-ivory leading-snug">
                {s.title}
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
